
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Chart } from "primereact/chart";

const Summary = ({farms}) => {
    const { t } = useTranslation();
    const countTypes = (arr) => {
        let dictionary = {};
        for (let i = 0; i < arr.length; i++) {
            if (dictionary[arr[i]]) {
                dictionary[arr[i]] += 1;
            } else {
                dictionary[arr[i]] = 1;
            }
        }
        return dictionary;
    };
    const node_types = farms.map((farm) => farm.tipo_nodos !== null ? farm.tipo_nodos : []).flat(1);
    const nodeTypeObj = countTypes(node_types);
    const totalFarms = farms.length;
    const totalNodes = farms.map((farm) => parseInt(farm.nodes)).reduce((partialSum, a) => partialSum + a, 0);
    const [chartData, setChartData] = useState({
        labels: Object.keys(nodeTypeObj),
        datasets: [
            {
                data: Object.values(nodeTypeObj)
            }]
    });

    const [lightOptions] = useState({
        plugins: {
            legend: {
                labels: {
                    color: "#495057"
                }
            }
        }
    });

    useEffect(() => {
        setChartData({
            labels: Object.keys(nodeTypeObj),
            datasets: [
                {
                    data: Object.values(nodeTypeObj)
                }]
        });
    }, [farms]);

    return (
        <div className="card grid p-fluid m-0">
            <div className="col-12 md:col-6">
                <div>
                    <div className="font-medium text-3xl text-900 mb-3">
                        {t("map.summary")}
                    </div>
                    <ul className="list-none p-0 m-0">
                        <li className="flex align-items-center justify-content-between py-3 px-2 border-top-1 border-300 flex-wrap">
                            <div className="text-500 w-6 md:w-2 font-medium">
                                {t("map.totalFarms")}
                            </div>
                            <div className="w-6 md:w-2 flex justify-content-end">
                                {totalFarms}
                            </div>
                        </li>
                        <li className="flex align-items-center justify-content-between py-3 px-2 border-top-1 border-300 flex-wrap">
                            <div className="text-500 w-6 md:w-2 font-medium">
                                {t("map.totalNodes")}
                            </div>
                            <div className="w-6 md:w-2 flex justify-content-end">
                                {totalNodes}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="col-12 md:col-6">
                <h5>
                    {t("map.nodeTypes")}
                </h5>
                <Chart type="doughnut" data={chartData} options={lightOptions} className="max-h-30rem h-30rem" />
            </div>
        </div>
    );
};

export default Summary;
